import type { HttpStatusCode } from './http_status_code';

/**
 * ## `@visiba/http`
 *
 *
 *
 */
export class HttpError<T> extends Error {
	constructor(
		public message: string,
		public statusCode: HttpStatusCode,
		public data: T,
	) {
		super(message);
		this.name = 'HttpError';
		Object.setPrototypeOf(this, HttpError.prototype);
	}
}

/**
 * ## `@visiba/http`
 *
 * Determines whether the payload is an error thrown by the Http module.
 *
 * ```tsx
 * try {
 * 	await Http.get('https://api.api.com');
 * } catch (error) {
 * 	if (isHttpError(error)) {
 * 		// The error is shaped as HttpError.
 * 	}
 *
 * 	throw error;
 * }
 * ```
 */
export function isHttpError<T>(error: unknown): error is HttpError<T> {
	if (error instanceof HttpError) {
		return true;
	}

	return false;
}
